export default "__VITE_ASSET__CwfjHaGg__"